import axios from 'axios';

axios.defaults.withCredentials = true;
//This is the api where the user authentication will happen
let baseUserUrl = process.env.REACT_APP_BACKEND_API

baseUserUrl = baseUserUrl + 'usersAuth';

//This is where the user will get word information as well as update his own word stats
let baseWordUrl = process.env.REACT_APP_BACKEND_API;
baseWordUrl = baseWordUrl + 'wordsApi'

export const AxiosAuth = axios.create({ baseURL: baseUserUrl });
export const AxiosWordAPI = axios.create({ baseURL: baseWordUrl });
